const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Imported Content Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {ImportedContent} ImportedContent injected to gain access to the ImportedContent resource
 */
app.controller('editImportedContent', ['Application', 'Authorization', 'ImportedContent', 'AdminContent', 'ContentIntegrations', 'Analyze', 'Viewables', 'AccessHelper', 'SurveyHelper', '$scope', '$location', '$q', '$translate', '$timeout', function(Application, Authorization, ImportedContent, AdminContent, ContentIntegrations, Analyze, Viewables, AccessHelper, SurveyHelper, $scope, $location, $q, $translate, $timeout) {
    var self = this;
    var routeParameters = Application.navigation.getRouteParameters();
    var newContent = !routeParameters.id || routeParameters.id === 'new' || routeParameters.id === 'linkedinlearning' || routeParameters.id === 'udemy' || routeParameters.id === 'masterclass';
    self.features = Application.features.flags();
    self.allowance = {
      create_imported_content: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'imported_content_create']], ['admin', 'creator', 'collaborator']),
      edit_imported_content: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'imported_content_edit']], ['admin', 'creator', 'collaborator']),
      add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
      add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),
    };

    if ((!newContent && !self.allowance.edit_imported_content) || (newContent && !self.allowance.create_imported_content)) {
      Application.navigation.goTo('/explore');
      return;
    }

    self.authtoken = Authorization.getAuthToken();
    self.user = self.authtoken.user;
    self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
    self.denied = false;
    self.editSaved = true;

    var locationChange = $scope.$on('$locationChangeStart', function(event) {
      if (self.editSaved) {
        // Allow the route change to progress
        self.denied = true;
        Application.messaging.clearMessages('trackstate');
        return;
      }

      // Halt the route change and question the action
      self.navigationPath = {};
      self.navigationPath.targetPath = Application.navigation.getPath();
      self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
      self.navigationPath.targetHash = Application.navigation.getHash();
      event.preventDefault();
      self.showDeparture = true;
      self.onLocationChange = function() {
        locationChange();
        Application.messaging.clearMessages('trackstate');
      };
    });
    self.showCollaborators = false;
    self.info = {
      integrationParams: {},
      course: {
        user: self.user._id,
        tags: [],
        instructors: [{
            image: '',
            full_name: '',
            bio: '',
            url: ''
          }],
        learn_items: [],
        allow_comments: false,
        duration: 0,
        privacy_collaborators: []
      },
      requiredFields: [],
      states: [],
      initializing: true,
      newCourse: true,
      cropAvatar: false,
      loading: false,
      vendorList: ['udemy'],
      mediumOpts: {
        'targetBlank': true,
        'toolbar': {
          'buttons': ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'quote', 'unorderedlist', 'orderedlist']
        }
      },
      allowImages: false,
      fields: 'company,user,title,instructors,vendor,vendor_link,vendor_full_link,vendor_content_id,description,headline,archived,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,linked_category,image,banner_image,cover_justification,featured_justification,explore_hide,duration,tags,type,learn_items,published,lil_structure,difficulty,rating_configuration,allow_comments,private,privacy_groups,surveys,partner_permissions',
      newLearnItem: '',
      addLearnItem: function() {
        if (!self.info.newLearnItem) {
          return;
        }
        self.info.course.learn_items.push(self.info.newLearnItem);
        self.info.newLearnItem = '';
        self.contentComms.blurSave('learn_items');
      }
    };

    self.instructors = {
      active: 0,
      editVersion: {},
      adding: false,
      beginNew: function(delay) {
        self.instructors.editVersion = {
          image: '',
          full_name: '',
          bio: '',
          url: ''
        };
        if (self.info.course.instructors.length > 7) {
          return;
        }
        if (!delay) {
          self.instructors.adding = true;
        }
      },
      remove: function(index) {
        if (index === 'edit') {
          self.instructors.beginNew();
          self.instructors.adding = false;
          return;
        }
        if (self.info.course.instructors && self.info.course.instructors[self.instructors.active]) {
          self.info.course.instructors.splice(self.instructors.active, 1);
          self.contentComms.blurSave('instructors');
          self.instructors.active = self.instructors.active === 0 ? 1 : self.instructors.active - 1;
        }
      },
      create: function() {
        if (!self.instructors.adding || !self.instructors.editVersion.full_name) {
          return;
        }
        self.instructors.adding = false;
        self.instructors.active = self.info.course.instructors.length;
        self.info.course.instructors.push(self.instructors.editVersion);
        self.contentComms.blurSave('instructors');
        self.instructors.beginNew(true);
      },
      addImage: function(link) {
        if (self.instructors.adding) {
          self.instructors.editVersion.image = link;
          return;
        }
        if (self.info.course.instructors && self.info.course.instructors[self.instructors.active]) {
          self.info.course.instructors[self.instructors.active].image = link;
          self.contentComms.blurSave('instructors');
        }
      }
    };

    self.navigation = {
      activeTab: 'add',
      closeViewer: function() {
        self.navigation.activeTab = 'settings';
      },
      goBack: function() {
        if (!self.denied || !self.backLocation) {
          Application.navigation.back();
          self.denied = true;
          return;
        }
        self.denied = true;
        var location = self.backLocation.split('/#/');
        if (location.length !== 2) {
          Application.navigation.back();
          return;
        }
        Application.navigation.goTo(location[1]);
      },
      nextSection: function(item) {
        var nextClicked = item ? false : true;
        var item = item ? self.navigation.directory[item].previous : self.navigation.activeTab;
        var next = self.navigation.directory[item].next;
        var missing = '';
        var allow = true;
        var skip_missing = false;

        var findIssues = function(check) {
          var current = self.navigation.directory[check];
          if (current.required) {
            for (var i = 0; i < current.required.length; i++) {
              if (!self.info.course[current.required[i]]) {
                allow = false;
                if (self.navigation.activeTab === 'add') {
                  missing = ' content,';
                  continue;
                }
                missing = missing + ' ' + current.required[i] + ',';
              }
            }
          }
          if (current.previous) {
            findIssues(current.previous);
          }
        };
        findIssues(item);

        if (allow && next) {
          if (self.info.newCourse || !nextClicked) {
            self.navigation.activeTab = next;
            Application.scrollTop();
            return;
          }
          Application.scrollTop();
          self.navigation.activeTab = next;
        }

        if (missing && !skip_missing) {
          Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
        }
      },
      directory: {
        'add': {
          next: 'details',
          previous: null,
          required: ['vendor', 'vendor_content_id']
        },
        'details': {
          next: 'images',
          previous: 'add',
          required: []
        },
        'images': {
          next: 'categories',
          previous: 'details',
          required: null
        },
        'categories': {
          next: 'settings',
          previous: 'images',
          required: null
        },
        'settings': {
          next: 'preview',
          previous: 'categories',
          required: null
        },
        'preview': {
          next: null,
          previous: 'settings',
          required: null
        }
      }
    };

    self.contentComms = {
      create: function() {
        // Check fields
        self.info.loading = true;
        if(self.user.is_collaborator) {
          self.info.course.approval_required = true;
          self.info.course.approved = false;
        }
        ImportedContent.create(self.info.course).$promise
        .then(function(item) {
          self.info.course = item;
          self.info.loading = false;
          self.info.newCourse = false;
          self.info.states.push(JSON.parse(JSON.stringify(self.info.course)));
          self.contentComms.showCreateModal = false;
          self.ignoreNext = true;
          self.editSaved = true;
          $location.path('/edit/imported-content/' + item._id);
          if (item.published) {
            $timeout(function() {
              self.editSaved = true;
              Application.navigation.goTo('/view/imported-content/' + item._id);
            }, 10);
          }
        }).catch(function(error) {
          self.info.loading = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          }
          console.log('error in creating imported content: ', error);
        });
      },
      save: function(body) {
        self.info.loading = true;
        if(self.user.is_collaborator) {
          body.approval_required = true;
          body.approved = false;
        }
        return ImportedContent.update({subresource: self.info.course._id, fields: self.info.fields}, body).$promise
        .then(function(course) {
          Analyze.record({resource: 'modifications'}, {document: self.info.course._id, type: 'imported_content'});
          Application.analyticsProvider.trackEvent('imported_content_updated', {content: self.info.course._id, content_type: 'imported_content', title: self.info.course.title});
          self.info.states.push(JSON.parse(JSON.stringify(course)));
          // This is a temporary fix for an issue with the add-edit-images directive going blank from replacing content with a new object while active
          if (body.featured_justification || body.cover_justification || body.image || body.banner_image) {
            Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['edit.assessment.saved']});
            self.info.loading = false;
            return;
          }
          self.info.course = course;
          self.info.loading = false;
          Application.messaging.addMessage({type: 'success', duration: 3, text: self.translations['edit.assessment.saved']});
          self.editSaved = true;
          self.ignoreNext = true;
          if (body.published) {
            var rp = Application.navigation.getRouteParameters();
            if (!rp.id) {
              self.editSaved = true;
              $location.path('/edit/imported-content/' + item._id);
            }
            $timeout(function() {
              self.editSaved = true;
              Application.navigation.goTo('/view/imported-content/' + course._id);
            }, 1);
          }
        }).catch(function(error) {
          self.info.loading = false;
          if (error.data && error.data.status === 401 && error.data.message) {
            Application.messaging.addMessage({type: 'error', duration: 7, text: error.data.message});
          }
          console.log('error in update: ', error);
        });
      },
      blurSave: function(field) {
        if (!self.info.course || !self.info.course._id || self.info.initializing) {
          return;
        }

        var previousState = self.info.states[self.info.states.length - 1];

        if (field !== 'private' && self.info.course[field] === previousState[field]) {
          return;
        }
        if (!self.info.course[field] && self.info.requiredFields.indexOf(field) !== -1) {
          self.info.course[field] = previousState[field];
          return;
        }

        var body = {};
        body[field] = self.info.course[field];

        if (field === 'private') {
          body.privacy_departments = self.info.course.privacy_departments;
          body.privacy_locations = self.info.course.privacy_locations;
          body.privacy_teams = self.info.course.privacy_teams;
          body.privacy_grades = self.info.course.privacy_grades;
          body.privacy_org_levels = self.info.course.privacy_org_levels;
          body.privacy_groups = self.info.course.privacy_groups;
          body.privacy_collaborators = self.info.course.privacy_collaborators;
        }

        self.contentComms.save(body);
      },
      showCreateModal: false,
      modalCreate: function(publish) {
        if (publish) {
          self.info.course.published = true;
        }
        self.contentComms.create();
      },
      publish: function() {
        self.info.course.published = true;
        self.contentComms.blurSave('published');
      },
      showDelete: false,
      archive: function() {
        if (!self.info.course._id) {
          return;
        }

        self.info.loading = true;
        self.archiveInfo = {};
        Viewables.archive({content: [{id: self.info.course._id, type: 'imported_content'}]}).$promise
            .then(function(results) {
              self.info.loading = false;
              self.contentComms.showDelete = false;
              self.archiveInfo.results = results;
              self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
              self.updateIndicator = false;
              self.showDelete = false;
              if (self.archiveInfo.show) {
                return;
              }
              self.editSaved = true;
              Analyze.record({resource: 'deletions'}, {document: self.info.course._id, type: 'imported_content'});
              Application.analyticsProvider.trackEvent('imported_content_deleted', {content: self.info.course._id, content_type: 'imported_content', title: self.info.course.title});
              Application.navigation.goTo('/admin/content');
              Application.messaging.addMessage({type: 'success', text: self.translations['edit.importedcontent.archived'], duration: 5});
            }).catch(function(err) {
          console.log('Error in update: ', err);
        });
      }
    };

    self.commentsChange = function() {
      self.contentComms.blurSave('allow_comments');
    };

    self.vendorComms = {
      importCourse: function(params) {
        if (params.vendor === 'udemy') {
          $q.all([
            ContentIntegrations.limitedFind({subresource: 'udemy'}).$promise,
            ContentIntegrations.udemyCourse({name: params.course}).$promise
          ]).then(function(results) {
            self.info.integrationParams = results[0];
            var course = results[1];
            self.vendorComms.processUdemyImport(course);
            self.navigation.activeTab = 'details';
            self.info.loading = false;
          }).catch(function(error) {
            // handle error
            console.log('error: ', error);
            self.info.loading = false;
          });
        }
        if (params.vendor === 'linkedin_learning') {
          self.info.loading = true;
          ContentIntegrations.lilCourse({name: params.course}).$promise
              .then(function(results) {
                var course = results;
                self.vendorComms.processLilImport(course);
                self.navigation.activeTab = 'details';
                self.info.loading = false;
              }).catch(function(error) {
            // handle error
            console.log('error: ', error);
            self.info.loading = false;
          });
        }
        if (params.vendor === 'masterclass') {
          self.info.loading = true;
          self.vendorComms.processMasterclassImport(params);
          self.navigation.activeTab = 'details';
          self.info.loading = false;
        }
      },
      processUdemyImport: function(item) {
        Object.assign(self.info.course, item);
        // Change things around here;
        delete self.info.course._id;
        self.info.course.user = self.user._id;
        self.info.course.vendor = 'udemy';
        self.info.course.vendor_link = item.url;
        self.info.course.vendor_full_link = 'https://' + self.info.integrationParams.portal_name + '.udemy.com' + item.url;
        self.info.course.vendor_content_id = item.id;
        if (item.context_info) {
          if (item.context_info.category && item.context_info.category.title) {
            self.info.course.tags.push(item.context_info.category.title);
          }
          if (item.context_info.label && item.context_info.label.display_name) {
            self.info.course.tags.push(item.context_info.label.display_name);
          }
        }
        if (item.visible_instructors && item.visible_instructors.length) {
          self.info.course.instructors.pop();
          item.visible_instructors.forEach(function(item) {
            var instructor = {
              full_name: item.display_name || '',
              image: item.image_200_H || item.image_100x100 || '',
              job_title: item.job_title || '',
              url: item.url || ''
            };
            self.info.course.instructors.push(instructor);
          });
        } else {
          self.instructors.beginNew();
        }

        if (item.objectives && item.objectives.length) {
          self.info.course.learn_items = item.objectives.slice(0, 3);
        }
        if (!self.info.course.learn_items.length && item.objectives_summary && item.objectives_summary.length) {
          self.info.course.learn_items = item.objectives_summary.slice(0, 3);
        }
        if (item.image_480x270) {
          self.info.course.image = item.image_480x270;
          self.info.course.banner_image = item.image_480x270;
        }
        if (item.image_750x422) {
          self.info.course.image = item.image_750x422;
          self.info.course.banner_image = item.image_750x422;
        }
        if (item.content_length_video) {
          self.info.course.duration = item.content_length_video;
        }
        self.info.allowImages = true;
        self.info.states.push(JSON.parse(JSON.stringify(self.info.course)));
        self.info.initializing = false;
      },
      generateLilStructure: function(contents, list) {
        if (!contents || !contents.length || !list) {
          return;
        }
        contents.forEach(function(item) {
          var children = [];
          if (item && item.asset && item.asset.contents && item.asset.contents.length) {
            self.vendorComms.generateLilStructure(item.asset.contents, children);
          }

          var structureItem = {
            title: item && item.asset && item.asset.title && item.asset.title.value || '==',
            type: item && item.asset && item.asset.type || '--',
            children: children,
            difficulty: item && item.asset && item.asset.details && item.asset.details.level || '--'
          };
          if (item && item.asset && item.asset.details && item.asset.details.description && item.asset.details.description.value) {
            structureItem.description = item.asset.details.description.value;
          }

          var duration = 0;
          if (item && item.asset && item.asset.details && item.asset.details.timeToComplete) {
            duration = self.vendorComms.generateLiLDuration(item.asset.details.timeToComplete);
          }

          if (structureItem.type === 'CHAPTER') {
            duration = 0;
            children.forEach(function(child) {
              if (!child.duration) {
                return;
              }
              duration += child.duration;
            });
          }
          structureItem.duration = duration;

          list.push(structureItem);
        });
      },
      generateLiLDuration: function(item) {
        if (!item.duration) {
          return 0;
        }
        switch (item.unit) {
          case "SECOND" :
            return item.duration;
          case "MINUTE" :
            return item.duration * 60;
          case "HOUR" :
            return item.duration * 3600;
          default:
            return item.duration;
        }
      },
      processLilImport: function(item) {
        var link = item && item.details && item.details.urls && item.details.urls.webLaunch;
        if (!link) {
          console.log('error. No Link!');
          return;
        }
        delete self.info.course._id;
        self.info.course.user = self.user._id;
        self.info.course.vendor = 'linkedin_learning';
        self.info.course.vendor_link = link;
        self.info.course.vendor_full_link = link;
        self.info.course.vendor_content_id = item.urn;
        self.info.course.title = item.title && item.title.value || '';
        self.info.course.description = item.details && item.details.description && item.details.description.value || '';
        self.info.course.difficulty = item && item.details && item.details.level || '--';
        if (item.details && item.details.classifications && item.details.classifications.length) {
          item.details.classifications.forEach(function(item) {
            var name = item && item.associatedClassification && item.associatedClassification.name && item.associatedClassification.name.value || null;
            if (name) {
              self.info.course.tags.push(name);
            }
          });
        }
        if (item.details && item.details.contributors && item.details.contributors.length) {
          self.info.course.instructors.pop();
          item.details.contributors.forEach(function(item) {
            var instructor = {
              full_name: item.name && item.name.value || '',
              image: '',
              job_title: '',
              url: '',
              urn: item.urn
            };
            self.info.course.instructors.push(instructor);
          });
        } else {
          self.instructors.beginNew();
        }

        if (item.details.images && item.details.images.primary) {
          self.info.course.image = item.details.images.primary;
          self.info.course.banner_image = item.details.images.primary;
        }
        if (item.details && item.details.timeToComplete) {
          self.info.course.duration = self.vendorComms.generateLiLDuration(item.details.timeToComplete);
        }
        self.info.course.lil_structure = [];
        self.vendorComms.generateLilStructure(item.contents, self.info.course.lil_structure);
        self.info.allowImages = true;
        self.info.states.push(JSON.parse(JSON.stringify(self.info.course)));
        self.info.initializing = false;
      },
      processMasterclassImport: function(item) {
        var link = item.content_page;
        if (!link) {
          console.log('error. No Link!');
          return;
        }
        delete self.info.course._id;
        self.info.course.user = self.user._id;
        self.info.course.vendor = 'masterclass';
        self.info.course.vendor_link = link;
        self.info.course.vendor_full_link = link;
        self.info.course.vendor_content_id = item.id;
        self.info.course.title = item.title;
        self.info.course.description = item.summary;
        self.info.course.difficulty = '--';
        if (item.skills && item.skills.length) {
          item.skills.forEach(function(item) {
            self.info.course.tags.push(item.name);
          });
        }
        if (item.instructors && item.instructors.length) {
          self.info.course.instructors.pop();
          item.instructors.forEach(function(item) {
            var instructor = {
              full_name: item.name,
              image: '',
              job_title: '',
              url: '',
              urn: ''
            };
            self.info.course.instructors.push(instructor);
          });
        } else {
          self.instructors.beginNew();
        }

        self.info.course.image = item.image;
        self.info.course.banner_image = item.image;
        self.info.course.duration = item.duration_in_seconds;

        self.info.allowImages = true;
        self.info.states.push(JSON.parse(JSON.stringify(self.info.course)));
        self.info.initializing = false;
      }
    };

    self.importThenInit = function(item) {
      if (item.vendor && item.course) {
        self.info.loading = true;
        self.vendorComms.importCourse(item);
        return;
      }
    };

    self.startEditWatch = function() {
      $scope.$watch('importer.info.course', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        if (self.ignoreNext) {
          self.ignoreNext = false;
          return;
        }
        self.editSaved = false;
      }, true);

      $scope.$watch('importer.surveyAssociation.surveysData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
      }, true);

      $scope.$watch('importer.surveyAssociation.surveyIds', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.info.course.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
        self.contentComms.blurSave('surveys');
      }, true);
      $scope.$watch('importer.partners.partnerPermission', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.info.course.partner_permissions = newVal;
        self.contentComms.blurSave('partner_permissions');

      }, true);
    };

    self.surveyAssociation = {
      surveysData: [],
      surveyIds: [],
      omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
      initialIdsByType: {survey: []},
      initSurveyData: function() {
        self.surveyAssociation.initialIdsByType.survey = self.info.course.surveys;
        self.surveyAssociation.surveyIds.push(self.info.course.surveys[0].survey_id);
      }
    };

    self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

    self.initialize = function() {
      self.info.initializing = true;
      if (self.user.role !== 'admin' && self.user.role !== 'creator' && !self.user.is_collaborator) {
        Application.navigation.goTo('/explore');
        return;
      }

      if (routeParameters.id === 'udemy') {
        self.newType = 'udemy';
        if (self.user.is_collaborator) {
          self.info.course.privacy_collaborators.push(self.user._id);
        }
        self.startEditWatch();
        return;
      }

      if (routeParameters.id === 'linkedinlearning') {
        self.newType = 'linkedin_learning';
        if (self.user.is_collaborator) {
          self.info.course.privacy_collaborators.push(self.user._id);
        }
        self.startEditWatch();
        return;
      }

      if (routeParameters.id === 'masterclass') {
        self.newType = 'masterclass';
        if (self.user.is_collaborator) {
          self.info.course.privacy_collaborators.push(self.user._id);
        }
        self.startEditWatch();
        return;
      }

      if (!routeParameters.id) {
        Application.navigation.goTo('/overview/admin');
        return;
      }

      // if id, get and return
      if (routeParameters.id && routeParameters.id !== 'new') {
        self.info.newCourse = false;
        self.info.loading = true;
        AdminContent.get({subresource: routeParameters.id, fields: self.info.fields, types: 'imported_content'}).$promise.then(async function(course) {
          if (!course) {
            Application.navigation.goTo('/explore');
            return;
          }
          self.info.course = course;
          if (!self.info.course.privacy_collaborators) {
            self.info.course.privacy_collaborators = [];
          }
          if (self.info.course.privacy_collaborators.length && !self.user.is_collaborator) {
            self.showCollaborators = true;
          }
          self.info.loading = false;
          self.navigation.activeTab = 'details';
          self.info.states.push(JSON.parse(JSON.stringify(self.info.course)));
          self.info.allowImages = true;
          if (self.info.course.surveys.length) {
            self.surveyAssociation.initSurveyData();
          }
          if (self.info.course.partner_permissions) {
            self.partners.partnerPermission = self.info.course.partner_permissions;
          }
          self.info.initializing = false;
          self.startEditWatch();
        }).catch(function(error) {
          console.log('error in get: ', error);
        });
        return;
      }

    };

    $translate([
      'edit.general.notification_fieldsMissing',
      'edit.general.notification_titleMissing',
      'edit.general.notification_confirmLeave',
      'edit.assessment.saved',
      'edit.importedcontent.archived'
    ]).then(function(translations) {
      self.translations = translations;
    });

    self.initialize();

  }]);